import React from 'react';
import './about.css'; 

export default function About() {
  return (
    <section className="about-section">
      <div className="about-container">
        <h1>About Us</h1>
        <p>
          Welcome to our platform! We are committed to delivering content across diverse 
          categories to enrich your knowledge and keep you informed. Our main categories include:
        </p>
        <ul>
          <li>Indian History</li>
          <li>Hidden History</li>
          <li>Mysteries</li>
          <li>Movies</li>
          <li>Sports</li>
          <li>Politics</li>
          <li>India</li>
          <li>World</li>
          <li>Tech</li>
          <li>Lifestyle</li>
          <li>Health & Wealth</li>
        </ul>
        <h2>Our Tools and Services</h2>
        <p>
          We provide a range of tools to make your tasks easier and more efficient. Our tools include:
        </p>
        <ul>
          <li>Image to PDF Converter</li>
          <li>PDF to Text Converter</li>
          <li>Text to PDF Converter</li>
          <li>JSON to CSV Converter</li>
          <li>CSV to JSON Converter</li>
          <li>Images to Text Converter</li>
        </ul>
        <h2>Additional Services</h2>
        <p>
          We also offer calculators and tests to support students and professionals:
        </p>
        <ul>
          <li>SGPA and CGPA Calculators for engineering students</li>
          <li>Typing Test to enhance typing skills</li>
          <li>Mock Tests to prepare for exams like JEE and GATE</li>
        </ul>
        <h2>Why Choose Us?</h2>
        <p>
          Our goal is to provide quality resources and tools that cater to the needs of diverse audiences. Whether you're a student, a professional, or just someone looking for insightful content, we've got you covered!
        </p>
      </div>
    </section>
  );
}
